import { authenticationRoutes } from '@app/routes/auth';
import NotFoundErrorModule from '@modules/404.vue';
import Vue from 'vue';
import Router, { Route, RouteConfig } from 'vue-router';
import { getRoutes as getLivePreviewRoutes } from './routes/live-preview';
import { getRoutes as getPresentRoutes } from './routes/present';
import { routes as selectRoutes } from './routes/select';
import { getRoutes as getShareRoutes } from './routes/share';

Vue.use(Router);

async function getRoutes(): Promise<RouteConfig[]> {
	const routes: RouteConfig[] = [
		...authenticationRoutes,
		...selectRoutes,
		...(await getPresentRoutes()),
		...(await getShareRoutes()),
		...(await getLivePreviewRoutes()),
		{
			path: '*',
			name: 'errors.404',
			component: NotFoundErrorModule
		}
	];

	return routes;
}

export async function getRouter(): Promise<Router> {
	return new Router({
		mode: 'history',
		base: process.env.BASE_URL,
		routes: await getRoutes(),
		scrollBehavior(to: Route, from: Route, savedPosition: any): any {
			// share routes should not scroll during route changes
			// as if will most likely no jump to an ideal scroll position
			// so we disable automatic scrolling on route changes completely
			if (to.name === 'share') {
				return;
			}
			// all other routes use default behaviour
			// eslint-disable-next-line consistent-return
			return savedPosition || { x: 0, y: 0 };
		}
	});
}
